module.exports = __webpack_public_path__ + "img/ie_setting_00_Option2.0d4d52f4.jpg";